import Service from './Service';

/**
 * API az ügyfelek kezeléséhez
 * @extends Service
 */
class UgyfelTorzsService extends Service {
    /**
     * Ügyfelek listázása megadott kritériumok alapán
     * @param {number} birthDate az ügyfél születési ideje
     * @param {string} name ügyfél neve
     * @returns {AxiosPromise<any>}
     */
    // http://ujtarifa.sp/ugyfel/ugyfel-list/?name=teszt elek&page=1&birthDate=1979.09.04
    getUgyfelLista(name, birthDate) {
        return this.get('ugyfel/ugyfel-list?', {
            name,
            birthDate,
        });
    }

    getUgyfelListOldApi(birthdate, filter, limit, nem, nev, oldal) {
        return this.post('api/ugyfelLista/UgyfelLista', {
            pager: {
                birthdate,
                filter,
                limit,
                nem,
                nev,
                oldal,
            },
        });
    }

    getTulajdonos(id, ugyfazon) {
        return this.get('kgfb/kgfb-base-ugyfel-data/?', { id, ugyfazon });
    }

    /**
     * Ügyfél adatainak lekérdezése ügyfél azonosító alapján
     * @param {number} ugyfazon Ügyfél azonosító
     * @returns {AxiosPromise<any>}
     */
    // http://ujtarifa.sp/ugyfel/ugyfel/?ugyfazon=1366924&modozat=6
    getUgyfel(ugyfazon, modozat = null) {
        if (modozat) {
            return this.get('ugyfel/ugyfel?', { ugyfazon, modozat });
        }
        return this.post('api/ugyfel/ugyfelAdatok?', { ugyfazon });
    }

    /**
     * Ügyfél adatok mentése
     * @param {object} ugyfel ügyfél adatok
     * @returns {AxiosPromise<any>}
     */
    saveUgyfel(ugyfel) {
        return this.post('ugyfel/saveUgyfel', { ugyfel });
    }

    deleteUgyfel(ugyfazon) {
        return this.post('api/ugyfelLista/deleteUgyfel', { data: { ugyfazon } });
    }

    confirmClientEmail(ugyfel, code, szerzodoId = null) {
        if (typeof ugyfel?.ugyfazon === 'number' && ugyfel.ugyfazon > 0) {
            if (szerzodoId !== null) {
                return this.patch(`ugyfel/ugyfel-confirmation/?ugyfazon=${ugyfel.ugyfazon}`, {
                    code,
                    szerzodo_id: szerzodoId
                });
            }
            return this.patch(`ugyfel/ugyfel-confirmation/?ugyfazon=${ugyfel.ugyfazon}`, {
                code,
            });
        }
        alert('confirmClientEmail invalid parameter!');
        throw new Error('confirmClientEmail invalid parameter!');
    }

    sendConfirmationEmail(ugyfel, email, szerzodoId = null) {
        if (typeof ugyfel?.ugyfazon === 'number' && ugyfel.ugyfazon > 0) {
            if (szerzodoId !== null) {
                return this.post(`ugyfel/ugyfel-confirmation/?ugyfazon=${ugyfel.ugyfazon}`, {
                    email,
                    szerzodo_id: szerzodoId
                });
            }
            return this.post(`ugyfel/ugyfel-confirmation/?ugyfazon=${ugyfel.ugyfazon}`, {
                email,
            });
        }
        alert('sendConfirmationEmail invalid parameter!');
        throw new Error('sendConfirmationEmail invalid parameter!');
    }

    checkEmailConfirmed(ugyfel) {
        if (typeof ugyfel?.ugyfazon === 'number' && ugyfel.ugyfazon > 0) {
            return this.get(`ugyfel/ugyfel-confirmation/?ugyfazon=${ugyfel.ugyfazon}`);
        }
        alert('checkEmailConfirmed invalid parameter!');
        throw new Error('checkEmailConfirmed invalid parameter!');
    }

    sendMegbizasi(ugyfel) {
        return this.get('ugyfel/ugyfel-megbizasi?', { ugyfazon: ugyfel.ugyfazon });
    }

    sendTajekoztatoBiztositaskozvetitorol(email) {
        return this.get('api/BiztkozvTajekoztato/sendtajekoztatoinemail', {
            data: {
                idceg: 1,
                email,
            },
        });
    }

    sendAdatvedelmiTajekoztato(email) {
        return this.get('api/AdatvedelmiTajekoztato/sendEmail', {
            data: {
                idceg: 1,
                email,
            },
        });
    }

    getClientMasterData(ugyfazon, scenario) {
        return this.get(`ugyfel/torzs-ugyfel?ugyfazon=${ugyfazon}${scenario ? `&scenario=${scenario}` : ''}`);
    }
}

export default new UgyfelTorzsService('/');
